// TypeScript
// appSlice.ts (новый файл)
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppState {
  loading: boolean;
  initialized: boolean;
  error?: string | null;
}

const initialState: AppState = {
  loading: false,
  initialized: false,
  error: null,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setInitialized(state, action: PayloadAction<boolean>) {
      state.initialized = action.payload;
    },
    setAppError(state, action: PayloadAction<string | null | undefined>) {
      state.error = action.payload ?? null;
    },
    resetApp(state) {
      state.loading = false;
      state.initialized = false;
      state.error = null;
    },
  },
});

export const { setLoading, setInitialized, setAppError, resetApp } = appSlice.actions;
export default appSlice.reducer;
